/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { createAsyncThunk } from '@reduxjs/toolkit'
import { saveAs } from 'file-saver'

import { callErrorMsg } from 'helpers/errorMsg'
import { toastSuccess } from 'utils/toast'
import { push } from 'utils/helpers/router'
import {
  type DynamicPricePayloadType,
  type DynamicPricingQueryType,
  getDynamicPricingAPI,
  getDynamincPricingDetailAPI,
  postDynamicPricingAPI,
  putDynamicPricingAPI,
  cancelDynamicPricingAPI,
  downloadDynamincPriceAPI,
} from 'features/DynamicPricing/service/dynamicPricing'
import {
  CreatedDynamicPricingRouter,
  DynamicPricingTableRouter,
} from 'features/DynamicPricing/router'
import {
  sliceName,
  setLoading,
  setDynamicPricing,
  setDynamicPricingDetail,
  setDialogState,
  setQuery,
} from './dynamicPricingSlice'

export const setActQuery = createAsyncThunk(
  `${sliceName}/setActQuery`,
  async (query: DynamicPricingQueryType, { dispatch }) => {
    await dispatch(setQuery(query))
    dispatch(getDynamicPricing())
  },
)

export const getDynamicPricing = createAsyncThunk(
  `${sliceName}/getDynamicPricing`,
  async (_, { dispatch, getState }) => {
    try {
      dispatch(setLoading(true))
      const { dynamicPricing } = getState() as StoreStateType
      const { data } = await getDynamicPricingAPI(dynamicPricing.query)
      dispatch(setDynamicPricing(data))
      return data
    } catch (error) {
      callErrorMsg(error)
      return error
    } finally {
      dispatch(setLoading(false))
    }
  },
)

export const getDynamicPricingDetail = createAsyncThunk(
  `${sliceName}/getDynamicPricingDetail`,
  async (id: number, { dispatch }) => {
    try {
      dispatch(setLoading(true))
      const { data } = await getDynamincPricingDetailAPI(id)
      dispatch(setDynamicPricingDetail(data.data))
    } catch (error) {
      callErrorMsg(error)
    } finally {
      dispatch(setLoading(false))
    }
  },
)

export const createUpdateCancelDynamicPricing = createAsyncThunk(
  `${sliceName}/createUpdateCancelDynamicPricing`,
  async (
    {
      id,
      payload,
      apiType,
    }: { id?: number; payload?: DynamicPricePayloadType; apiType: 'create' | 'update' | 'cancel' },
    { dispatch },
  ) => {
    try {
      dispatch(setLoading(true))
      let createdId = 0

      if (apiType === 'create') {
        await postDynamicPricingAPI(payload!)
        const respAction = await dispatch(getDynamicPricing())
        const resp = respAction.payload as { data: { id: number }[] } | undefined
        createdId = resp?.data?.[0]?.id || 0
        toastSuccess('Experiment berhasil dibuat')
      }

      if (apiType === 'update') {
        await putDynamicPricingAPI(id!, payload!)
        toastSuccess('Experiment berhasil diubah')
      }

      if (apiType === 'cancel') {
        await cancelDynamicPricingAPI(id!)
      }

      dispatch(
        push({
          url:
            apiType === 'create'
              ? CreatedDynamicPricingRouter.path
              : DynamicPricingTableRouter.path,
          paramsUrl: apiType === 'create' ? { id: createdId } : {},
        }),
      )
      dispatch(setDialogState({ isOpen: false, type: '' }))
    } catch (error) {
      callErrorMsg(error)
    } finally {
      dispatch(setLoading(false))
    }
  },
)

export const downloadDynamicPricing = createAsyncThunk(
  `${sliceName}/downloadDynamicPricing`,
  async (id: number, { dispatch }) => {
    try {
      dispatch(setLoading(true))
      const { data } = await downloadDynamincPriceAPI(id)
      saveAs(data.data.file_url)
    } catch (error) {
      callErrorMsg(error)
    } finally {
      dispatch(setLoading(false))
    }
  },
)
